package api

@Suppress("ClassName")
sealed class ResourceType(val mask: Int, val key: String, @Suppress("unused") val label: String) {


    data object UNDEFINED : ResourceType(1, "UNDEFINED", "All")
    data object IMAGE : ResourceType(2, "IMAGE", "Image")
    data object VIDEO : ResourceType(4, "VIDEO", "Video")
    data object DOCUMENT : ResourceType(8, "PDF", "Document")
    data object WWW_APP : ResourceType(16, "WWW_APP", "Web App")
    data object TEXT : ResourceType(32, "TEXT", "Large text")
    data object ICON : ResourceType(64, "ICON", "Icon")
    data object VIDEO_ALPHA : ResourceType(128, "VIDEO_ALPHA", "Alpha video")
    data object AUDIO : ResourceType(256, "AUDIO", "AUDIO")
    data object RAW : ResourceType(512, "RAW", "RAW")

    infix fun match(mask: Int): Boolean = this.mask and mask > 0

    @Suppress("unused")
    infix fun ResourceType.and(other: ResourceType): Int = mask + other.mask

    companion object {

        const val NO_IMAGE = -9999L
        @Suppress("unused")
        const val NO_ICON = NO_IMAGE

        val all by lazy {
            listOf(
                UNDEFINED,
                IMAGE,
                VIDEO,
                DOCUMENT,
                WWW_APP,
                TEXT,
                ICON,
                VIDEO_ALPHA,
                AUDIO,
                RAW
            )
        }

        operator fun get(type: Int): ResourceType {
            return all.firstOrNull { it match type } ?: UNDEFINED
        }

        operator fun get(key: String): ResourceType {
            return all.firstOrNull { it.key == key.uppercase() } ?: UNDEFINED
        }
    }
}
